import { useEffect } from 'react';

import { CurrentInputType } from 'src/viewLayer/components/nodes/InputNode/types';

// Reset password field when changing node, so that the user cannot accidentally register on a different node
// (1 field will always be missing from the API call).
export const useClearPasswordField = (nodeInputs: string[], currentInput: CurrentInputType): void => {
  useEffect(() => {
    if (!nodeInputs.includes('password')) currentInput.password.setInputValue('');
  }, [nodeInputs, currentInput.password]);
};
